import { computed, defineComponent } from '@vue/composition-api';
const ProgressBar = defineComponent({
    props: {
        progress: { type: Number, required: true },
        goal: { type: Number, required: true },
        ignored: { type: Number, required: true },
    },
    setup(props) {
        const goalPercent = computed(() => {
            return (props.goal / 100) * (100 - props.ignored);
        });
        return {
            goalPercent,
        };
    }
});
export default ProgressBar;
